module.exports = __webpack_public_path__ + "static/media/915ty@2x.d00a35f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/915ty@2x.png
// module id = 1701
// module chunks = 0 1